import '../../styles/templates/search.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Search Template');
});
